import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
